import PurchaseTypes from '@/common/enums/purchase-types.enum';
import PackageCustomProperty from '@/common/models/package/PackageCustomProperty';
import Validatable from '@/validator/Validatable';

export default class MembershipSettings extends Validatable {
  allowDealLineItemDateModification: boolean;

  allowExchangeFeeOverride: boolean;

  audienceGeoStatisticsUrl: string;

  availableCustomReportTypes: string;

  availableLocationIDs: number[];

  cacheDspCreatives: string;

  canEditExchangeLineItems: boolean;

  creativeProperties: Record<string, string[]>;

  currencySymbol: string;

  defaultAdServerLogoUrl: string;

  defaultAdServerName: string;

  dspBrandingImage: string;

  dspBrandingName: string;

  dspLineItemMaxStartDaysInAdvance: number;

  enableOverbookedReservedImpressions: boolean;

  enableTakeoverPurchaseType: boolean;

  exchangeBrandingImage: string;

  exchangeBrandingName: string;

  externalAvailsUrl: string;

  isDiscountEditingEnabled: boolean;

  packageCustomProperties: PackageCustomProperty[];

  reportPostProcessIsbaNetReachFrequency: boolean;

  sspBrandingImage: string;

  sspBrandingName: string;

  uiDSPAvailablePurchaseTypes: string[];

  uiEnableAppDomainID: boolean;

  uiEnableAudienceAudit: boolean;

  uiEnableAudienceCPM: boolean;

  uiEnableAudienceLogics: boolean;

  uiEnableAuditTrails: boolean;

  uiEnableAvailsImport: boolean;

  uiEnablePredictiveAvails: boolean;

  uiEnableBetaFeatures: boolean;

  uiEnableCompanionAd: boolean;

  uiEnableCustomAudienceExternalDemographics: boolean;

  uiEnableDeliveryForecast: boolean;

  uiEnableDeliveryForecastIsbaAmendments: boolean;

  uiEnableDemoFeatures: boolean;

  uiEnableDisplayOfSiteIDNextToSiteName: boolean;

  uiEnableEnvironicsPrizm: boolean;

  uiEnableGeofenceGroups: boolean;

  uiEnableGeofenceGroupsRulesInAudienceLogics: boolean;

  uiEnableGeofenceGroupTargeting: boolean;

  uiEnableLiAccessIfAdServerOff: boolean;

  uiEnableLineItemAdDuration: boolean;

  uiEnableLineItemCheckAvails: boolean;

  uiEnableLineItemDaypart: boolean;

  uiEnableLineItemDemographics: boolean;

  uiEnableLineItemMobileRetargeting: boolean;

  uiEnableLineItemSiteTargeting: boolean;

  uiEnableLineItemUnitTargeting: boolean;

  uiEnableMobileLineItems: boolean;

  uiEnablePackageAdDuration: boolean;

  uiEnablePackageCheckAvails: boolean;

  uiEnablePackageDaypart: boolean;

  uiEnablePMPDeals: boolean;

  uiEnablePreSaleHeatmaps: boolean;

  uiEnableReportDefinitionMetricForPlays: boolean;

  uiEnableRevenueStream: boolean;

  uiEnableStorefrontDeals: boolean;

  uiEnableUpdatedInventoryExport: boolean;

  uiForceNetworkSelectionInLineitemsAndDeals: boolean;

  uiHideLatitudeLongitude: boolean;

  uiHideReportFees: boolean;

  uiHideUnitReporting: boolean;

  uiSSPAlwaysShowLineItemCreatives: boolean;

  uiDefaultLineItemMapFilters: string;

  minimumLineItemImpressionsToEnableMeasurementRequests: number;

  uiEnableAirportAudiences: boolean;

  uiEnableMovieAudiences: boolean;

  uiAvailableLineItemMapFilters: string;

  uiEnableLineItemMeasurementRequest: boolean;

  uiEnableLiveView: boolean;

  uiEnableAlphaFeatures: boolean;

  uiEnableCadenceBuys: boolean;

  uiEnableAudienceFiles: boolean;

  uiEnableLineItemDealID: boolean;

  uiMakeMaxBidRequired: boolean;

  lineItemMinimumTargetedImpressions: string;

  bidRequestUnitInformation: Record<string, boolean>;

  useRedshiftForReports: boolean;

  useInventoryTargetingForCreativeApproval: boolean;

  uiEnableReportDefLegacyOption: boolean;

  uiEnablePerformanceOptimization: boolean;

  uiEnableCustomEventManagement: boolean;

  uiEnableCampaignPacing: boolean;

  uiEnableCampaignDailyCaps: boolean;

  uiEnableDemandPriorityManagement: boolean;

  uiEnableDynamicGeofences: boolean;

  uiEnableAgencyMargins: boolean;

  uiEnableAgencyBudgetMargins: boolean;

  enableBonusBuys: boolean;

  uiEnableMultiSSP: boolean;

  enableAdvertiserRFP: boolean;

  enableCampaignBudgetCapField: boolean;

  allowZeroFixedRateCPM: boolean;

  uiEnableInsertionOrderBudget: boolean;

  uiEnableReachAndFrequency: boolean;

  uiEnableReachAndFrequencyReports: boolean;

  uiEnableForecastedReach: boolean;

  enablePlansFeature: boolean;

  uiDefaultAdDuration: boolean;

  uiDefaultFloorCpm: number;

  enableMoFixedAdDurationOverride: boolean;

  isUnitVenueTypeRequired: boolean;

  uiEnableSelectTargetingToSeeScreens: boolean;

  yieldManagerAuctionOptions: Record<string, string>;

  uiEnableAudienceConcentrationDetails: boolean;

  uiEnableDirectBilling: boolean;

  defaultSalesRep: string;

  baseDataProviderCode: string;

  uiEnableFlights: boolean;

  uiEnableAttachableFees: boolean;

  enableDisplayVideoChannel: boolean;

  explicitTargetedUnitsMax: number;

  implicitTargetedUnitsMax: number;

  uiEnableCpmStrategy: boolean;

  uiEnableFeeBreakdown: boolean;

  enableGenAIAudienceRecommendation: boolean;

  campaignAgencyMargin: number;

  enableJourneys: boolean;

  curatePrivateDealsAllowed: boolean;

  playerOrganizationId: number;

  isOfflinePlaysEnabled: boolean;

  constructor(
    allowDealLineItemDateModification?,
    allowExchangeFeeOverride?,
    audienceGeoStatisticsUrl?,
    availableCustomReportTypes?,
    availableLocationIDs?,
    cacheDspCreatives?,
    canEditExchangeLineItems?,
    creativeProperties = {},
    currencySymbol?,
    defaultAdServerLogoUrl?,
    defaultAdServerName?,
    dspBrandingImage?,
    dspBrandingName?,
    dspLineItemMaxStartDaysInAdvance?,
    enableOverbookedReservedImpressions?,
    enableTakeoverPurchaseType?,
    exchangeBrandingImage?,
    exchangeBrandingName?,
    externalAvailsUrl?,
    isDiscountEditingEnabled?,
    packageCustomProperties?,
    reportPostProcessIsbaNetReachFrequency?,
    sspBrandingImage?,
    sspBrandingName?,
    uiDSPAvailablePurchaseTypes?,
    uiEnableAppDomainID?,
    uiEnableAudienceAudit?,
    uiEnableAudienceCPM?,
    uiEnableAudienceLogics?,
    uiEnableAuditTrails?,
    uiEnableAvailsImport?,
    uiEnablePredictiveAvails?,
    uiEnableBetaFeatures?,
    uiEnableCompanionAd?,
    uiEnableCustomAudienceExternalDemographics?,
    uiEnableDeliveryForecast?,
    uiEnableDeliveryForecastIsbaAmendments?,
    uiEnableDisplayOfSiteIDNextToSiteName?,
    uiEnableEnvironicsPrizm?,
    uiEnableGeofenceGroups?,
    uiEnableGeofenceGroupsRulesInAudienceLogics?,
    uiEnableGeofenceGroupTargeting?,
    uiEnableLiAccessIfAdServerOff?,
    uiEnableLineItemAdDuration?,
    uiEnableLineItemCheckAvails?,
    uiEnableLineItemDaypart?,
    uiEnableLineItemDemographics?,
    uiEnableLineItemMobileRetargeting?,
    uiEnableLineItemSiteTargeting?,
    uiEnableLineItemUnitTargeting?,
    uiEnableMobileLineItems?,
    uiEnablePackageAdDuration?,
    uiEnablePackageCheckAvails?,
    uiEnablePackageDaypart?,
    uiEnablePMPDeals?,
    uiEnablePreSaleHeatmaps?,
    uiEnableReportDefinitionMetricForPlays?,
    uiEnableRevenueStream?,
    uiEnableStorefrontDeals?,
    uiEnableUpdatedInventoryExport?,
    uiForceNetworkSelectionInLineitemsAndDeals?,
    uiHideLatitudeLongitude?,
    uiHideReportFees?,
    uiHideUnitReporting?,
    uiSSPAlwaysShowLineItemCreatives?,
    uiDefaultLineItemMapFilters?,
    minimumLineItemImpressionsToEnableMeasurementRequests?,
    uiEnableAirportAudiences?,
    uiEnableMovieAudiences?,
    uiAvailableLineItemMapFilters?,
    uiEnableLineItemMeasurementRequest?,
    uiEnableLiveView?,
    uiEnableAlphaFeatures?,
    uiEnableCadenceBuys?,
    uiEnableAudienceFiles?,
    uiEnableLineItemDealID?,
    uiMakeMaxBidRequired?,
    lineItemMinimumTargetedImpressions?,
    bidRequestUnitInformation?,
    useRedshiftForReports?,
    useInventoryTargetingForCreativeApproval?,
    uiEnableReportDefLegacyOption?,
    uiEnablePerformanceOptimization?,
    uiEnableCustomEventManagement?,
    uiEnableCampaignPacing?,
    uiEnableCampaignDailyCaps?,
    uiEnableDemandPriorityManagement?,
    uiEnableDynamicGeofences?,
    uiEnableAgencyMargins?,
    enableBonusBuys?,
    uiEnableMultiSSP?,
    enableAdvertiserRFP?,
    enableCampaignBudgetCapField?,
    allowZeroFixedRateCPM?,
    uiEnableInsertionOrderBudget?,
    uiEnableReachAndFrequency?,
    uiEnableReachAndFrequencyReports?,
    enablePlansFeature?,
    uiDefaultAdDuration?,
    uiDefaultFloorCpm?,
    isUnitVenueTypeRequired?,
    uiEnableSelectTargetingToSeeScreens?,
    uiEnableDirectBilling?,
    defaultSalesRep?,
    uiEnableAudienceConcentrationDetails?,
    baseDataProviderCode?,
    uiEnableFlights?,
    uiEnableAttachableFees?,
    uiEnableForecastedReach?,
    uiEnableAgencyBudgetMargins?,
    enableDisplayVideoChannel?,
    explicitTargetedUnitsMax?,
    implicitTargetedUnitsMax?,
    uiEnableCpmStrategy?,
    uiEnableFeeBreakdown?,
    campaignAgencyMargin?,
    enableGenAIAudienceRecommendation?,
    enableJourneys?,
    curatePrivateDealsAllowed?,
    playerOrganizationId?,
    isOfflinePlaysEnabled?,
  ) {
    super();
    this.allowDealLineItemDateModification = allowDealLineItemDateModification;
    this.allowExchangeFeeOverride = allowExchangeFeeOverride;
    this.audienceGeoStatisticsUrl = audienceGeoStatisticsUrl;
    this.availableCustomReportTypes = availableCustomReportTypes;
    this.availableLocationIDs = availableLocationIDs;
    this.cacheDspCreatives = cacheDspCreatives;
    this.canEditExchangeLineItems = canEditExchangeLineItems;
    this.creativeProperties = creativeProperties;
    this.currencySymbol = currencySymbol;
    this.defaultAdServerLogoUrl = defaultAdServerLogoUrl;
    this.defaultAdServerName = defaultAdServerName;
    this.dspBrandingImage = dspBrandingImage;
    this.dspBrandingName = dspBrandingName;
    this.dspLineItemMaxStartDaysInAdvance = dspLineItemMaxStartDaysInAdvance;
    this.enableOverbookedReservedImpressions = enableOverbookedReservedImpressions;
    this.enableTakeoverPurchaseType = enableTakeoverPurchaseType;
    this.exchangeBrandingImage = exchangeBrandingImage;
    this.exchangeBrandingName = exchangeBrandingName;
    this.externalAvailsUrl = externalAvailsUrl;
    this.isDiscountEditingEnabled = isDiscountEditingEnabled;
    this.packageCustomProperties = packageCustomProperties;
    this.reportPostProcessIsbaNetReachFrequency = reportPostProcessIsbaNetReachFrequency;
    this.sspBrandingImage = sspBrandingImage;
    this.sspBrandingName = sspBrandingName;
    this.uiDSPAvailablePurchaseTypes = uiDSPAvailablePurchaseTypes;
    this.uiEnableAppDomainID = uiEnableAppDomainID;
    this.uiEnableAudienceAudit = uiEnableAudienceAudit;
    this.uiEnableAudienceCPM = uiEnableAudienceCPM;
    this.uiEnableAudienceLogics = uiEnableAudienceLogics;
    this.uiEnableAuditTrails = uiEnableAuditTrails;
    this.uiEnableAvailsImport = uiEnableAvailsImport;
    this.uiEnablePredictiveAvails = uiEnablePredictiveAvails;
    this.uiEnableBetaFeatures = uiEnableBetaFeatures;
    this.uiEnableCompanionAd = uiEnableCompanionAd;
    this.uiEnableCustomAudienceExternalDemographics = uiEnableCustomAudienceExternalDemographics;
    this.uiEnableDeliveryForecast = uiEnableDeliveryForecast;
    this.uiEnableDeliveryForecastIsbaAmendments = uiEnableDeliveryForecastIsbaAmendments;
    this.uiEnableDisplayOfSiteIDNextToSiteName = uiEnableDisplayOfSiteIDNextToSiteName;
    this.uiEnableEnvironicsPrizm = uiEnableEnvironicsPrizm;
    this.uiEnableGeofenceGroups = uiEnableGeofenceGroups;
    this.uiEnableGeofenceGroupsRulesInAudienceLogics = uiEnableGeofenceGroupsRulesInAudienceLogics;
    this.uiEnableGeofenceGroupTargeting = uiEnableGeofenceGroupTargeting;
    this.uiEnableLiAccessIfAdServerOff = uiEnableLiAccessIfAdServerOff;
    this.uiEnableLineItemAdDuration = uiEnableLineItemAdDuration;
    this.uiEnableLineItemCheckAvails = uiEnableLineItemCheckAvails;
    this.uiEnableLineItemDaypart = uiEnableLineItemDaypart;
    this.uiEnableLineItemDemographics = uiEnableLineItemDemographics;
    this.uiEnableLineItemMobileRetargeting = uiEnableLineItemMobileRetargeting;
    this.uiEnableLineItemSiteTargeting = uiEnableLineItemSiteTargeting;
    this.uiEnableLineItemUnitTargeting = uiEnableLineItemUnitTargeting && uiEnableLineItemSiteTargeting;
    this.uiEnableMobileLineItems = uiEnableMobileLineItems;
    this.uiEnablePackageAdDuration = uiEnablePackageAdDuration;
    this.uiEnablePackageCheckAvails = uiEnablePackageCheckAvails;
    this.uiEnablePackageDaypart = uiEnablePackageDaypart;
    this.uiEnablePMPDeals = uiEnablePMPDeals;
    this.uiEnablePreSaleHeatmaps = uiEnablePreSaleHeatmaps;
    this.uiEnableReportDefinitionMetricForPlays = uiEnableReportDefinitionMetricForPlays;
    this.uiEnableRevenueStream = uiEnableRevenueStream;
    this.uiEnableStorefrontDeals = uiEnableStorefrontDeals;
    this.uiEnableUpdatedInventoryExport = uiEnableUpdatedInventoryExport;
    this.uiForceNetworkSelectionInLineitemsAndDeals = uiForceNetworkSelectionInLineitemsAndDeals;
    this.uiHideLatitudeLongitude = uiHideLatitudeLongitude;
    this.uiHideReportFees = uiHideReportFees;
    this.uiHideUnitReporting = uiHideUnitReporting;
    this.uiSSPAlwaysShowLineItemCreatives = uiSSPAlwaysShowLineItemCreatives;
    this.uiDefaultLineItemMapFilters = uiDefaultLineItemMapFilters;
    this.minimumLineItemImpressionsToEnableMeasurementRequests = minimumLineItemImpressionsToEnableMeasurementRequests;
    this.uiEnableAirportAudiences = uiEnableAirportAudiences;
    this.uiEnableMovieAudiences = uiEnableMovieAudiences;
    this.uiAvailableLineItemMapFilters = uiAvailableLineItemMapFilters;
    this.uiEnableLineItemMeasurementRequest = uiEnableLineItemMeasurementRequest;
    this.uiEnableLiveView = uiEnableLiveView;
    this.uiEnableAlphaFeatures = uiEnableAlphaFeatures;
    this.uiEnableCadenceBuys = uiEnableCadenceBuys;
    this.uiEnableAudienceFiles = uiEnableAudienceFiles;
    this.uiEnableLineItemDealID = uiEnableLineItemDealID;
    this.uiMakeMaxBidRequired = uiMakeMaxBidRequired;
    this.lineItemMinimumTargetedImpressions = lineItemMinimumTargetedImpressions;
    this.bidRequestUnitInformation = bidRequestUnitInformation;
    this.useRedshiftForReports = useRedshiftForReports;
    this.useInventoryTargetingForCreativeApproval = useInventoryTargetingForCreativeApproval;
    this.uiEnableReportDefLegacyOption = uiEnableReportDefLegacyOption;
    this.uiEnablePerformanceOptimization = uiEnablePerformanceOptimization;
    this.uiEnableCustomEventManagement = uiEnableCustomEventManagement;
    this.uiEnableCampaignPacing = uiEnableCampaignPacing;
    this.uiEnableCampaignDailyCaps = uiEnableCampaignDailyCaps;
    this.uiEnableDemandPriorityManagement = uiEnableDemandPriorityManagement;
    this.uiEnableDynamicGeofences = uiEnableDynamicGeofences;
    this.uiEnableAgencyMargins = uiEnableAgencyMargins;
    this.uiEnableAgencyBudgetMargins = uiEnableAgencyBudgetMargins;
    this.enableBonusBuys = enableBonusBuys;
    this.uiEnableMultiSSP = uiEnableMultiSSP;
    this.enableAdvertiserRFP = enableAdvertiserRFP;
    this.enableCampaignBudgetCapField = enableCampaignBudgetCapField;
    this.allowZeroFixedRateCPM = allowZeroFixedRateCPM;
    this.uiEnableInsertionOrderBudget = uiEnableInsertionOrderBudget;
    this.uiEnableReachAndFrequency = uiEnableReachAndFrequency;
    this.uiEnableReachAndFrequencyReports = uiEnableReachAndFrequencyReports;
    this.uiEnableForecastedReach = uiEnableForecastedReach;
    this.enablePlansFeature = enablePlansFeature;
    this.uiDefaultAdDuration = uiDefaultAdDuration;
    this.uiDefaultFloorCpm = uiDefaultFloorCpm;
    this.isUnitVenueTypeRequired = isUnitVenueTypeRequired;
    this.uiEnableSelectTargetingToSeeScreens = uiEnableSelectTargetingToSeeScreens;
    this.uiEnableDirectBilling = uiEnableDirectBilling;
    this.defaultSalesRep = defaultSalesRep;
    this.uiEnableAudienceConcentrationDetails = uiEnableAudienceConcentrationDetails;
    this.baseDataProviderCode = baseDataProviderCode;
    this.uiEnableFlights = uiEnableFlights;
    this.uiEnableAttachableFees = uiEnableAttachableFees;
    this.enableDisplayVideoChannel = enableDisplayVideoChannel;
    this.explicitTargetedUnitsMax = explicitTargetedUnitsMax;
    this.implicitTargetedUnitsMax = implicitTargetedUnitsMax;
    this.uiEnableCpmStrategy = uiEnableCpmStrategy;
    this.uiEnableFeeBreakdown = uiEnableFeeBreakdown;
    this.campaignAgencyMargin = campaignAgencyMargin;
    this.enableGenAIAudienceRecommendation = enableGenAIAudienceRecommendation;
    this.enableJourneys = enableJourneys;
    this.curatePrivateDealsAllowed = curatePrivateDealsAllowed;
    this.playerOrganizationId = playerOrganizationId;
    this.isOfflinePlaysEnabled = isOfflinePlaysEnabled;
  }

  get adServerLogoUrl() {
    return this.defaultAdServerLogoUrl ? `/assets/images/${this.defaultAdServerLogoUrl}` : '';
  }

  get canHideUnitInformationInBidRequests() {
    return this.bidRequestUnitInformation != null && this.bidRequestUnitInformation.can_hide === true;
  }

  get defaultStateForHidingUnitInformationInBidRequests() {
    return this.bidRequestUnitInformation != null && this.bidRequestUnitInformation.default_hide === true;
  }

  static fromApi(apiObject) {
    return super.fromObject(
      {
        allowDealLineItemDateModification:
          apiObject.allow_deal_lineitem_date_modification !== undefined
            ? apiObject.allow_deal_lineitem_date_modification === 'true'
            : false,
        allowExchangeFeeOverride:
          apiObject.allow_exchange_fee_override !== undefined
            ? apiObject.allow_exchange_fee_override === 'true'
            : false,
        audienceGeoStatisticsUrl: apiObject.audience_geo_statistics_url || '',
        availableLocationIDs:
          apiObject.available_location_ids !== null &&
          apiObject.available_location_ids !== undefined &&
          apiObject.available_location_ids.trim() !== ''
            ? apiObject.available_location_ids.split(',')
            : null,
        availableCustomReportTypes: apiObject.available_custom_report_types || '',
        bidRequestUnitInformation:
          apiObject.bid_request_unit_information != null ? JSON.parse(apiObject.bid_request_unit_information) : null,
        cacheDspCreatives: apiObject.cache_dsp_creatives === 'true',
        canEditExchangeLineItems:
          apiObject.can_edit_exchange_lineitems !== undefined ? apiObject.can_edit_exchange_lineitems === 'true' : true,
        creativeProperties: apiObject.creative_properties !== null ? JSON.parse(apiObject.creative_properties) : null,
        currencySymbol: apiObject.currency_symbol,
        defaultAdServerLogoUrl: apiObject.default_ad_server_logo_url || null,
        defaultAdServerName: apiObject.default_ad_server_name || null,
        dspBrandingImage: apiObject.dsp_branding_image,
        dspBrandingName: apiObject.dsp_branding_name,
        dspLineItemMaxStartDaysInAdvance:
          apiObject.dsp_lineitem_max_start_days_in_advance !== undefined
            ? parseInt(apiObject.dsp_lineitem_max_start_days_in_advance, 10)
            : 2000,
        enableOverbookedReservedImpressions:
          apiObject.enable_overbooked_reserved_impressions !== undefined
            ? apiObject.enable_overbooked_reserved_impressions === 'true'
            : false,
        exchangeBrandingImage: apiObject.exchange_branding_image,
        exchangeBrandingName: apiObject.exchange_branding_name,
        externalAvailsUrl: apiObject.external_avails_url,
        isDiscountEditingEnabled:
          apiObject.ui_enable_discounts_editing !== undefined
            ? apiObject.ui_enable_discounts_editing === 'true'
            : false,
        packageCustomProperties:
          apiObject.package_custom_properties != null
            ? JSON.parse(apiObject.package_custom_properties).map((x) => PackageCustomProperty.fromApi(x))
            : [],
        reportPostProcessIsbaNetReachFrequency:
          apiObject.report_post_process_isba_net_reach_frequency !== undefined
            ? Object.keys(JSON.parse(apiObject.report_post_process_isba_net_reach_frequency)).length !== 0
            : false,
        sspBrandingImage: apiObject.ssp_branding_image,
        sspBrandingName: apiObject.ssp_branding_name,
        uiDSPAvailablePurchaseTypes:
          apiObject.ui_dsp_available_purchase_types !== undefined
            ? apiObject.ui_dsp_available_purchase_types.split(',')
            : [PurchaseTypes.NON_GUARANTEED, PurchaseTypes.GUARANTEED],
        uiEnableAppDomainID: apiObject.ui_enable_app_domain_id ? apiObject.ui_enable_app_domain_id === 'true' : false,
        uiEnableAudienceAudit: apiObject.ui_enable_audience_audit_feature
          ? apiObject.ui_enable_audience_audit_feature === 'true'
          : false,
        uiEnableAudienceCPM:
          apiObject.ui_enable_audience_cpm == null ? false : apiObject.ui_enable_audience_cpm === 'true',
        uiEnableAudienceLogics:
          apiObject.ui_enable_audience_logics !== undefined ? apiObject.ui_enable_audience_logics === 'true' : false,
        uiEnableAuditTrails:
          apiObject.ui_enable_audit_trails !== undefined ? apiObject.ui_enable_audit_trails === 'true' : false,
        uiEnableAvailsImport:
          apiObject.external_avails_url !== undefined ? apiObject.external_avails_url === 'imported-avails' : false,
        uiEnablePredictiveAvails:
          apiObject.external_avails_url !== undefined ? apiObject.external_avails_url === 'predictive-avails' : false,
        uiEnableBetaFeatures:
          apiObject.ui_enable_beta_features !== undefined ? apiObject.ui_enable_beta_features === 'true' : false,
        uiEnableCappedImpressionsReport:
          apiObject.available_custom_report_types !== undefined
            ? apiObject.available_custom_report_types.includes('capped_impressions')
            : false,
        uiEnableAllVisionBillingReport:
          apiObject.available_custom_report_types !== undefined
            ? apiObject.available_custom_report_types.includes('allvision_billing')
            : false,
        uiEnableFillRateReport:
          apiObject.available_custom_report_types !== undefined
            ? apiObject.available_custom_report_types.includes('fill_rate')
            : false,
        uiEnableActiveAgentReport:
          apiObject.available_custom_report_types !== undefined
            ? apiObject.available_custom_report_types.includes('active_agent_report')
            : false,
        uiEnableCompanionAd:
          apiObject.ui_enable_companion_ad !== undefined ? apiObject.ui_enable_companion_ad === 'true' : true,
        uiEnableContendingLineItemReport:
          apiObject.available_custom_report_types !== undefined
            ? apiObject.available_custom_report_types.includes('contending_lineitems')
            : false,
        uiEnableCustomAudienceExternalDemographics:
          apiObject.ui_enable_custom_audience_external_demographics !== undefined
            ? apiObject.ui_enable_custom_audience_external_demographics === 'true'
            : true,
        uiEnableDeliveryForecast:
          apiObject.ui_enable_delivery_forecast !== undefined
            ? apiObject.ui_enable_delivery_forecast === 'true'
            : false,
        uiEnableDeliveryForecastIsbaAmendments:
          apiObject.ui_enable_delivery_forecast_isba_amendments !== undefined
            ? apiObject.ui_enable_delivery_forecast_isba_amendments === 'true'
            : false,
        uiEnableDemoFeatures:
          apiObject.ui_enable_demo_features !== undefined ? apiObject.ui_enable_demo_features === 'true' : false,
        uiEnableDisplayOfSiteIDNextToSiteName:
          apiObject.ui_enable_display_of_site_id_next_to_site_name !== undefined
            ? apiObject.ui_enable_display_of_site_id_next_to_site_name === 'true'
            : false,
        uiEnableEnvironicsPrizm:
          apiObject.ui_enable_environics_prizm !== undefined ? apiObject.ui_enable_environics_prizm === 'true' : false,
        uiEnableGeofenceGroups:
          apiObject.ui_enable_geofence_groups !== undefined ? apiObject.ui_enable_geofence_groups === 'true' : false,
        uiEnableGeofenceGroupsRulesInAudienceLogics:
          apiObject.ui_enable_geofence_groups_rules_in_audience_logics !== undefined
            ? apiObject.ui_enable_geofence_groups_rules_in_audience_logics === 'true'
            : false,
        uiEnableGeofenceGroupTargeting:
          apiObject.ui_enable_geofence_group_targeting !== undefined
            ? apiObject.ui_enable_geofence_group_targeting === 'true'
            : false,
        uiEnableLiAccessIfAdServerOff:
          apiObject.ui_enable_li_access_if_ad_server_off !== undefined
            ? apiObject.ui_enable_li_access_if_ad_server_off === 'true'
            : false,
        uiEnableLineItemAdDuration:
          apiObject.ui_enable_lineitem_ad_duration !== undefined
            ? apiObject.ui_enable_lineitem_ad_duration === 'true'
            : true,
        uiEnableLineItemCheckAvails:
          apiObject.ui_enable_lineitem_check_avails !== undefined
            ? apiObject.ui_enable_lineitem_check_avails === 'true'
            : true,
        uiEnableLineItemDaypart:
          apiObject.ui_enable_lineitem_daypart !== undefined ? apiObject.ui_enable_lineitem_daypart === 'true' : true,
        uiEnableLineItemDemographics:
          apiObject.ui_enable_lineitem_demographics !== undefined
            ? apiObject.ui_enable_lineitem_demographics === 'true'
            : true,
        uiEnableLineItemMobileRetargeting:
          apiObject.ui_enable_lineitem_mobile_retargeting !== undefined
            ? apiObject.ui_enable_lineitem_mobile_retargeting === 'true'
            : false,
        uiEnableLineItemSiteTargeting:
          apiObject.ui_enable_lineitem_site_targeting !== undefined
            ? apiObject.ui_enable_lineitem_site_targeting === 'true'
            : true,
        uiEnableLineItemUnitTargeting:
          apiObject.ui_enable_lineitem_unit_targeting !== undefined
            ? apiObject.ui_enable_lineitem_unit_targeting === 'true'
            : false,
        uiEnableMobileLineItems: apiObject.ui_enable_mobile_lineitems
          ? apiObject.ui_enable_mobile_lineitems === 'true'
          : false,
        uiEnablePackageAdDuration:
          apiObject.ui_enable_package_ad_duration !== undefined
            ? apiObject.ui_enable_package_ad_duration === 'true'
            : true,
        uiEnablePackageCheckAvails:
          apiObject.ui_enable_package_check_avails !== undefined
            ? apiObject.ui_enable_package_check_avails === 'true'
            : true,
        uiEnablePackageDaypart:
          apiObject.ui_enable_package_daypart !== undefined ? apiObject.ui_enable_package_daypart === 'true' : true,
        uiEnablePMPDeals:
          apiObject.ui_enable_pmp_deals !== undefined ? apiObject.ui_enable_pmp_deals === 'true' : false,
        uiEnablePreSaleHeatmaps:
          apiObject.ui_enable_presale_heatmaps !== undefined ? apiObject.ui_enable_presale_heatmaps === 'true' : false,
        uiEnableReportDefinitionMetricForPlays:
          apiObject.ui_enable_report_definition_metric_for_plays !== undefined
            ? apiObject.ui_enable_report_definition_metric_for_plays === 'true'
            : true,
        uiEnableRevenueStream:
          apiObject.ui_enable_revenue_stream !== undefined ? apiObject.ui_enable_revenue_stream === 'true' : false,
        uiEnableStorefrontDeals:
          apiObject.ui_enable_storefront_deals !== undefined ? apiObject.ui_enable_storefront_deals === 'true' : false,
        uiEnableUpdatedInventoryExport:
          apiObject.ui_enable_updated_inventory_export !== undefined
            ? apiObject.ui_enable_updated_inventory_export !== '' &&
              apiObject.ui_enable_updated_inventory_export !== 'false'
            : false,
        uiForceNetworkSelectionInLineitemsAndDeals:
          apiObject.ui_force_network_selection_in_lineitems_and_deals !== undefined
            ? apiObject.ui_force_network_selection_in_lineitems_and_deals === 'true'
            : false,
        uiHideLatitudeLongitude:
          apiObject.ui_hide_latitude_longitude == null ? false : apiObject.ui_hide_latitude_longitude === 'true',
        uiHideReportFees: apiObject.ui_hide_report_fees == null ? false : apiObject.ui_hide_report_fees === 'true',
        uiHideUnitReporting:
          apiObject.ui_hide_unit_reporting == null ? false : apiObject.ui_hide_unit_reporting === 'true',
        useInventoryTargetingForCreativeApproval:
          apiObject.use_inventory_targeting_for_creative_approval !== undefined
            ? apiObject.use_inventory_targeting_for_creative_approval === 'true'
            : false,
        uiSSPAlwaysShowLineItemCreatives:
          apiObject.ui_ssp_lineitem_always_show_creatives !== undefined
            ? apiObject.ui_ssp_lineitem_always_show_creatives === 'true'
            : false,
        uiDefaultLineItemMapFilters:
          apiObject.ui_lineitem_map_default_filters_visible !== undefined
            ? apiObject.ui_lineitem_map_default_filters_visible
            : null,
        minimumLineItemImpressionsToEnableMeasurementRequests:
          apiObject.ui_min_li_imp_to_enable_measurement_requests == null
            ? 2000000
            : parseInt(apiObject.ui_min_li_imp_to_enable_measurement_requests, 10),
        uiEnableAirportAudiences:
          apiObject.ui_enable_movies_audiences !== undefined ? apiObject.ui_enable_movies_audiences === 'true' : false,
        uiEnableMovieAudiences:
          apiObject.ui_enable_movies_audiences !== undefined ? apiObject.ui_enable_movies_audiences === 'true' : false,
        uiAvailableLineItemMapFilters:
          apiObject.ui_lineitem_map_available_filters !== undefined ? apiObject.ui_lineitem_map_available_filters : '',
        uiEnableLineItemMeasurementRequest:
          apiObject.ui_enable_lineitem_measurement_request != null
            ? apiObject.ui_enable_lineitem_measurement_request === 'true'
            : apiObject.ui_enable_beta_features === 'true',
        uiEnableLiveView:
          apiObject.ui_enable_live_view !== undefined ? apiObject.ui_enable_live_view === 'true' : false,
        uiEnableAlphaFeatures:
          apiObject.ui_enable_alpha_features !== undefined ? apiObject.ui_enable_alpha_features === 'true' : false,
        uiEnableCadenceBuys:
          apiObject.ui_enable_cadence_buys !== undefined ? apiObject.ui_enable_cadence_buys === 'true' : false,
        uiEnableAudienceFiles:
          apiObject.ui_enable_audience_files !== undefined ? apiObject.ui_enable_audience_files === 'true' : false,
        uiEnableLineItemDealID:
          apiObject.ui_enable_line_item_deal_id !== undefined
            ? apiObject.ui_enable_line_item_deal_id === 'true'
            : false,
        uiMakeMaxBidRequired:
          apiObject.ui_make_max_bid_required !== undefined ? apiObject.ui_make_max_bid_required === 'true' : false,
        lineItemMinimumTargetedImpressions: apiObject.line_item_minimum_targeted_impressions,
        useRedshiftForReports:
          apiObject.use_redshift_for_reports !== undefined ? apiObject.use_redshift_for_reports === 'true' : false,
        uiEnableReportDefLegacyOption:
          apiObject.ui_enable_report_def_legacy_option !== undefined
            ? apiObject.ui_enable_report_def_legacy_option === 'true'
            : false,
        uiEnableCampaignLineItemsEditingUsingSpreadsheets:
          apiObject.ui_enable_campaign_lineitems_editing_spreadsheets !== undefined
            ? apiObject.ui_enable_campaign_lineitems_editing_spreadsheets === 'true'
            : false,
        uiEnablePerformanceOptimization:
          apiObject.ui_enable_performance_optimization !== undefined
            ? apiObject.ui_enable_performance_optimization === 'true'
            : false,
        uiEnableCustomEventManagement:
          apiObject.ui_enable_custom_event_management !== undefined
            ? apiObject.ui_enable_custom_event_management === 'true'
            : false,
        uiEnableCampaignPacing:
          apiObject.ui_enable_campaign_pacing !== undefined ? apiObject.ui_enable_campaign_pacing === 'true' : false,
        uiEnableCampaignDailyCaps:
          apiObject.ui_enable_campaign_daily_caps !== undefined
            ? apiObject.ui_enable_campaign_daily_caps === 'true'
            : false,
        uiEnableDemandPriorityManagement:
          apiObject.ui_enable_demand_priority_management !== undefined
            ? apiObject.ui_enable_demand_priority_management === 'true'
            : false,
        uiEnableDynamicGeofences:
          apiObject.ui_enable_dynamic_geofences !== undefined
            ? apiObject.ui_enable_dynamic_geofences === 'true'
            : false,
        uiEnableAgencyMargins:
          apiObject.ui_enable_agency_margins !== undefined ? apiObject.ui_enable_agency_margins === 'true' : false,
        uiEnableAgencyBudgetMargins:
          apiObject.ui_enable_budget_agency_margins !== undefined
            ? apiObject.ui_enable_budget_agency_margins === 'true'
            : false,
        enableBonusBuys: apiObject.enable_bonus_buys !== undefined ? apiObject.enable_bonus_buys === 'true' : false,
        uiEnableMultiSSP:
          apiObject.ui_enable_multi_ssp !== undefined ? apiObject.ui_enable_multi_ssp === 'true' : false,
        enableAdvertiserRFP:
          apiObject.enable_advertiser_rfp !== undefined ? apiObject.enable_advertiser_rfp === 'true' : false,
        enableCampaignBudgetCapField:
          apiObject.enable_campaign_budget_cap_field !== undefined
            ? apiObject.enable_campaign_budget_cap_field === 'true'
            : false,
        allowZeroFixedRateCPM:
          apiObject.allow_zero_fixed_rate_cpm !== undefined ? apiObject.allow_zero_fixed_rate_cpm === 'true' : true,
        uiEnableInsertionOrderBudget:
          apiObject.ui_enable_insertion_order_budget !== undefined
            ? apiObject.ui_enable_insertion_order_budget === 'true'
            : true,
        uiEnableReachAndFrequency:
          apiObject.ui_enable_reach_and_frequency !== undefined
            ? apiObject.ui_enable_reach_and_frequency === 'true'
            : false,
        uiEnableReachAndFrequencyReports:
          apiObject.ui_enable_reach_and_frequency_reports !== undefined
            ? apiObject.ui_enable_reach_and_frequency_reports === 'true'
            : false,
        uiEnableForecastedReach:
          apiObject.forecasted_reach_and_frequency !== undefined
            ? apiObject.forecasted_reach_and_frequency === 'true'
            : false,
        enablePlansFeature:
          apiObject.enable_plans_feature !== undefined ? apiObject.enable_plans_feature === 'true' : false,
        uiDefaultAdDuration:
          apiObject.ui_default_ad_duration !== undefined ? parseInt(apiObject.ui_default_ad_duration, 10) : 10,
        uiDefaultFloorCpm:
          apiObject.ui_default_floor_cpm !== undefined ? parseFloat(apiObject.ui_default_floor_cpm) : 10,
        enableMoFixedAdDurationOverride:
          apiObject.enable_mo_fixed_ad_duration_override !== undefined
            ? apiObject.enable_mo_fixed_ad_duration_override === 'true'
            : false,
        uiEnableNetworksForHSBuyers:
          apiObject.ui_enable_networks_for_hs_buyers !== undefined
            ? apiObject.ui_enable_networks_for_hs_buyers === 'true'
            : false,
        enableTakeoverPurchaseType:
          apiObject.enable_takeover_purchase_type !== undefined
            ? apiObject.enable_takeover_purchase_type === 'true'
            : false,
        isUnitVenueTypeRequired:
          apiObject.is_unit_venue_type_required !== undefined ? apiObject.is_unit_venue_type_required === 'true' : true,
        uiEnableSelectTargetingToSeeScreens:
          apiObject.ui_enable_select_targeting_to_see_screens !== undefined
            ? apiObject.ui_enable_select_targeting_to_see_screens === 'true'
            : false,
        yieldManagerAuctionOptions:
          apiObject.yield_manager_auction_options != null ? JSON.parse(apiObject.yield_manager_auction_options) : null,
        uiEnableDirectBilling:
          apiObject.ui_enable_direct_billing !== undefined ? apiObject.ui_enable_direct_billing === 'true' : false,
        defaultSalesRep: apiObject.default_sales_rep !== undefined ? apiObject.default_sales_rep : null,
        uiEnableAudienceConcentrationDetails:
          apiObject.ui_enable_audience_concentration_details !== undefined
            ? apiObject.ui_enable_audience_concentration_details === 'true'
            : false,
        baseDataProviderCode: apiObject.dataprovider_code_for_base_demographics,
        uiEnableFlights: apiObject.ui_enable_flights !== undefined ? apiObject.ui_enable_flights === 'true' : false,
        uiEnableAttachableFees: apiObject.ui_enable_attachable_fees === 'true',
        enableDisplayVideoChannel: apiObject.enable_display_video_channel === 'true',
        explicitTargetedUnitsMax: parseInt(apiObject.explicit_targeted_units_max, 10),
        implicitTargetedUnitsMax: parseInt(apiObject.implicit_targeted_units_max, 10),
        uiEnableCpmStrategy: apiObject.ui_enable_cpm_strategy === 'true',
        uiEnableFeeBreakdown: apiObject.ui_enable_fee_breakdown === 'true',
        campaignAgencyMargin: Number(apiObject.campaign_agency_margin),
        enableGenAIAudienceRecommendation: apiObject.enable_gen_ai_audience_recommendations === 'true',
        enableJourneys: apiObject.enable_journeys === 'true',
        curatePrivateDealsAllowed: apiObject.curate_private_deals_allowed === 'true',
        curateAllowDirectBillingDeals: apiObject.curate_allow_direct_billing_deals === 'true',
        playerOrganizationId: apiObject.player_organization_uid,
        isOfflinePlaysEnabled: apiObject.ui_enable_offline_plays === 'true',
      },
      new MembershipSettings(),
    );
  }

  toApi() {
    return {
      allow_deal_lineitem_date_modification: this.allowExchangeFeeOverride ? 'true' : 'false',
      allow_exchange_fee_override: this.allowExchangeFeeOverride ? 'true' : 'false',
      audience_geo_statistics_url: this.audienceGeoStatisticsUrl,
      available_custom_report_types: this.availableCustomReportTypes,
      available_location_ids: this.availableLocationIDs != null ? this.availableLocationIDs.join(',') : null,
      cache_dsp_creatives: this.cacheDspCreatives ? 'true' : 'false',
      can_edit_exchange_lineitems: this.canEditExchangeLineItems ? 'true' : 'false',
      creative_properties: JSON.stringify(this.creativeProperties),
      currency_symbol: this.currencySymbol,
      default_ad_server_logo_url: this.defaultAdServerLogoUrl,
      default_ad_server_name: this.defaultAdServerName,
      dsp_branding_image: this.dspBrandingImage,
      dsp_branding_name: this.dspBrandingName,
      dsp_lineitem_max_start_days_in_advance: `${this.dspLineItemMaxStartDaysInAdvance}`,
      enable_overbooked_reserved_impressions: this.enableOverbookedReservedImpressions ? 'true' : 'false',
      exchange_branding_image: this.exchangeBrandingImage,
      exchange_branding_name: this.exchangeBrandingName,
      external_avails_url: this.externalAvailsUrl,
      package_custom_properties: this.packageCustomProperties.map((x) => x.toApi()),
      ssp_branding_image: this.sspBrandingImage,
      ssp_branding_name: this.sspBrandingName,
      ui_dsp_available_purchase_types: this.uiDSPAvailablePurchaseTypes.join(','),
      ui_enable_app_domain_id: this.uiEnableAppDomainID ? 'true' : 'false',
      ui_enable_audience_audit_feature: this.uiEnableAudienceAudit ? 'true' : 'false',
      ui_enable_audience_cpm: this.uiEnableAudienceCPM ? 'true' : 'false',
      ui_enable_audience_logics: this.uiEnableAudienceLogics ? 'true' : 'false',
      ui_enable_audit_trails: this.uiEnableAuditTrails ? 'true' : 'false',
      ui_enable_beta_features: this.uiEnableBetaFeatures ? 'true' : 'false',
      ui_enable_companion_ad: this.uiEnableCompanionAd ? 'true' : 'false',
      ui_enable_custom_audience_external_demographics: this.uiEnableCustomAudienceExternalDemographics
        ? 'true'
        : 'false',
      ui_enable_delivery_forecast: this.uiEnableDeliveryForecast ? 'true' : 'false',
      ui_enable_delivery_forecast_isba_amendments: this.uiEnableDeliveryForecastIsbaAmendments ? 'true' : 'false',
      ui_enable_demo_features: this.uiEnableDemoFeatures ? 'true' : 'false',
      ui_enable_discounts_editing: this.isDiscountEditingEnabled ? 'true' : 'false',
      ui_enable_display_of_site_id_next_to_site_name: this.uiEnableDisplayOfSiteIDNextToSiteName ? 'true' : 'false',
      ui_enable_environics_prizm: this.uiEnableEnvironicsPrizm ? 'true' : 'false',
      ui_enable_geofence_group_targeting: this.uiEnableGeofenceGroupTargeting ? 'true' : 'false',
      ui_enable_geofence_groups: this.uiEnableGeofenceGroups ? 'true' : 'false',
      ui_enable_geofence_groups_rules_in_audience_logics: this.uiEnableGeofenceGroupsRulesInAudienceLogics
        ? 'true'
        : 'false',
      ui_enable_li_access_if_ad_server_off: this.uiEnableLiAccessIfAdServerOff ? 'true' : false,
      ui_enable_lineitem_ad_duration: this.uiEnableLineItemAdDuration ? 'true' : 'false',
      ui_enable_lineitem_check_avails: this.uiEnableLineItemCheckAvails ? 'true' : 'false',
      ui_enable_lineitem_daypart: this.uiEnableLineItemDaypart ? 'true' : 'false',
      ui_enable_lineitem_demographics: this.uiEnableLineItemDemographics ? 'true' : 'false',
      ui_enable_lineitem_mobile_retargeting: this.uiEnableLineItemMobileRetargeting ? 'true' : 'false',
      ui_enable_lineitem_site_targeting: this.uiEnableLineItemSiteTargeting ? 'true' : 'false',
      ui_enable_lineitem_unit_targeting: this.uiEnableLineItemUnitTargeting ? 'true' : 'false',
      ui_enable_mobile_lineitems: this.uiEnableMobileLineItems ? 'true' : 'false',
      ui_enable_package_ad_duration: this.uiEnablePackageAdDuration ? 'true' : 'false',
      ui_enable_package_check_avails: this.uiEnablePackageCheckAvails ? 'true' : 'false',
      ui_enable_package_daypart: this.uiEnablePackageDaypart ? 'true' : 'false',
      ui_enable_pmp_deals: this.uiEnablePMPDeals ? 'true' : 'false',
      ui_enable_presale_heatmaps: this.uiEnablePreSaleHeatmaps ? 'true' : 'false',
      ui_enable_report_definition_metric_for_plays: this.uiEnableReportDefinitionMetricForPlays ? 'true' : 'false',
      ui_enable_revenue_stream: this.uiEnableRevenueStream ? 'true' : 'false',
      ui_enable_updated_inventory_export: this.uiEnableUpdatedInventoryExport ? 'true' : 'false',
      ui_force_network_selection_in_lineitems_and_deals: this.uiForceNetworkSelectionInLineitemsAndDeals
        ? 'true'
        : 'false',
      ui_hide_latitude_longitude: this.uiHideLatitudeLongitude ? 'true' : 'false',
      ui_hide_report_fees: this.uiHideReportFees ? 'true' : 'false',
      ui_hide_unit_reporting: this.uiHideUnitReporting ? 'true' : 'false',
      ui_ssp_lineitem_always_show_creatives: this.uiSSPAlwaysShowLineItemCreatives ? 'true' : 'false',
      ui_lineitem_map_default_filters_visible:
        this.uiDefaultLineItemMapFilters == null ? '' : this.uiDefaultLineItemMapFilters,
      ui_min_li_imp_to_enable_measurement_requests: `${this.minimumLineItemImpressionsToEnableMeasurementRequests}`,
      ui_enable_airport_audiences: this.uiEnableAirportAudiences ? 'true' : 'false',
      ui_enable_movies_audiences: this.uiEnableMovieAudiences ? 'true' : 'false',
      ui_lineitem_map_available_filters:
        this.uiAvailableLineItemMapFilters == null ? '' : this.uiAvailableLineItemMapFilters,
      ui_enable_lineitem_measurement_request: this.uiEnableLineItemMeasurementRequest ? 'true' : 'false',
      ui_enable_live_view: this.uiEnableLiveView ? 'true' : 'false',
      ui_enable_alpha_features: this.uiEnableAlphaFeatures ? 'true' : 'false',
      ui_enable_cadence_buys: this.uiEnableCadenceBuys ? 'true' : 'false',
      ui_enable_audience_files: this.uiEnableAudienceFiles ? 'true' : 'false',
      ui_enable_line_item_deal_id: this.uiEnableLineItemDealID ? 'true' : 'false',
      ui_make_max_bid_required: this.uiMakeMaxBidRequired ? 'true' : 'false',
      bid_request_unit_information:
        this.bidRequestUnitInformation != null ? JSON.stringify(this.bidRequestUnitInformation) : null,
      line_item_minimum_targeted_impressions: this.lineItemMinimumTargetedImpressions,
      use_inventory_targeting_for_creative_approval: this.useInventoryTargetingForCreativeApproval,
      use_redshift_for_reports: this.useRedshiftForReports,
      ui_enable_report_def_legacy_option: this.uiEnableReportDefLegacyOption,
      ui_enable_performance_optimization: this.uiEnablePerformanceOptimization,
      ui_enable_custom_event_management: this.uiEnableCustomEventManagement,
      ui_enable_campaign_pacing: this.uiEnableCampaignPacing,
      ui_enable_campaign_daily_caps: this.uiEnableCampaignDailyCaps,
      ui_enable_demand_priority_management: this.uiEnableDemandPriorityManagement,
      ui_enable_dynamic_geofences: this.uiEnableDynamicGeofences,
      ui_enable_agency_margins: this.uiEnableAgencyMargins,
      ui_enable_budget_agency_margins: this.uiEnableAgencyBudgetMargins,
      enable_bonus_buys: this.enableBonusBuys,
      ui_enable_multi_ssp: this.uiEnableMultiSSP,
      enable_advertiser_rfp: this.enableAdvertiserRFP,
      enable_campaign_budget_cap_field: this.enableCampaignBudgetCapField,
      allow_zero_fixed_rate_cpm: this.allowZeroFixedRateCPM,
      ui_enable_insertion_order_budget: this.uiEnableInsertionOrderBudget,
      ui_enable_reach_and_frequency: this.uiEnableReachAndFrequency,
      ui_enable_reach_and_frequency_reports: this.uiEnableReachAndFrequencyReports,
      forecasted_reach_and_frequency: this.uiEnableForecastedReach,
      enable_plans_feature: this.enablePlansFeature,
      ui_default_ad_duration: this.uiDefaultAdDuration,
      ui_default_floor_cpm: this.uiDefaultFloorCpm,
      enable_mo_fixed_ad_duration_override: this.enableMoFixedAdDurationOverride,
      enable_takeover_purchase_type: this.enableTakeoverPurchaseType,
      is_unit_venue_type_required: this.isUnitVenueTypeRequired ? 'true' : 'false',
      ui_enable_select_targeting_to_see_screens: this.uiEnableSelectTargetingToSeeScreens,
      yield_manager_auction_options:
        this.yieldManagerAuctionOptions != null ? JSON.stringify(this.yieldManagerAuctionOptions) : null,
      ui_enable_direct_billing: this.uiEnableDirectBilling,
      default_sales_rep: this.defaultSalesRep,
      ui_enable_audience_concentration_details: this.uiEnableAudienceConcentrationDetails,
      dataprovider_code_for_base_demographics: this.baseDataProviderCode,
      ui_enable_flights: this.uiEnableFlights,
      ui_enable_attachable_fees: this.uiEnableAttachableFees ? 'true' : 'false',
      enable_display_video_channel: this.enableDisplayVideoChannel,
      explicit_targeted_units_max: this.explicitTargetedUnitsMax,
      implicit_targeted_units_max: this.implicitTargetedUnitsMax,
      ui_enable_cpm_strategy: this.uiEnableCpmStrategy,
      ui_enable_fee_breakdown: this.uiEnableFeeBreakdown,
      enable_gen_ai_audience_recommendations: this.enableGenAIAudienceRecommendation,
      enable_journeys: this.enableJourneys,
      curate_private_deals_allowed: this.curatePrivateDealsAllowed,
      curate_allow_direct_billing_deals: this.curateAllowDirectBillingDeals,
      player_organization_uid: this.playerOrganizationId,
      is_offline_plays_enabled: this.isOfflinePlaysEnabled,
    };
  }
}
